import { Link } from "react-router-dom"
import Logo from "assets/images/logo.png"

export default function NotFound() {
  return (
    <div className="font-sans min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-800 mb-1">404</h1>
        <p className="text-xl text-gray-600 mb-8">Oops! Page not found.</p>
        <p className="text-base text-gray-500 mb-0">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <p className="text-base mt-0 mb-8">
          If the problem persists, please{" "}
          <a href="mailto:support@getdashfuel.com" className="underline">
            contact us
          </a>
          .
        </p>
        <Link
          to="/"
          className="bg-primary-blue hover:bg-primary-blue/90 text-white font-bold py-[8px] px-3 rounded-md transition duration-300"
        >
          Return Home
        </Link>
      </div>
    </div>
  )
}
